export default __webpack_public_path__ + "static/media/60C.93214398.jpg";